module.exports = __webpack_public_path__ + "img/2.10.36303180.png";